import styled from "styled-components";

export const IndexSignUpCtaComponentMainDiv = styled.section`
  > div {
    display: flex;
    flex-direction: column;
    gap: 60px;
    padding: 100px 40px;
    align-items: center;
  }
  .singup-cta-container {
    width: 100%;
    max-width: 100%;
    display: flex;
    gap: 60px;
    align-items: center;
    justify-content: center;

    max-width: 1140px;
  }
  .singup-cta-wrapper {
    display: flex;
    gap: 16px;
    flex-flow: column;
    align-items: center;
    max-width: 725px;
    flex: 1;
    width: 100%;
  }
  .singup-cta-icon-wraper {
    width: 80px;
    height: 80px;
    border-radius: 100%;
    overflow: hidden;
    > img {
      border-radius: 100%;
    }
  }
  .cta-bottom-contaner {
    display: flex;
    flex-flow: column;
    gap: 32px;
    align-items: center;
    width: 100;
  }
  .cta-header-contaner {
    display: flex;
    flex-flow: column;
    gap: 24px;
  }
  .cta-text-wrapper {
    text-align: center;
    > h2 {
    }
    > p {
    }
  }

  .cta-button-contaier {
    display: flex;
    gap: 16px;
    align-items: center;
  }
  .cta-button-wrapper {
    display: flex;

    min-width: 176px;
  }
`;
